/* eslint-disable import/prefer-default-export */
import Notes from './components/Notes.react';

export {
    Notes
};
